module.exports = __webpack_public_path__ + "img/home-nav-icon-2.589fe1fa.png";